import { render, staticRenderFns } from "./PackagesTable.vue?vue&type=template&id=8d7f7414&scoped=true&"
import script from "./PackagesTable.vue?vue&type=script&lang=js&"
export * from "./PackagesTable.vue?vue&type=script&lang=js&"
import style0 from "./PackagesTable.vue?vue&type=style&index=0&id=8d7f7414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7f7414",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VDataTable,VSpacer})
